// Gestão de Estoque (Facilities). Espelha backend/config.py ROLES_ESTOQUE_* — mantenha em
// sincronia. Decisão 2026-09-25: só admin + FACILITIES + VIAGEMFACILITIES acessam o módulo.
export const ROLES_ESTOQUE_OPERADOR = ["admin", "FACILITIES", "VIAGEMFACILITIES"];
export const ROLES_ESTOQUE_FINANCEIRO = ["admin", "FACILITIES", "VIAGEMFACILITIES"];
export const ROLES_ESTOQUE_ADMIN = ["admin"];
export const ROLES_ESTOQUE = Array.from(new Set([...ROLES_ESTOQUE_OPERADOR, ...ROLES_ESTOQUE_FINANCEIRO, ...ROLES_ESTOQUE_ADMIN]));

export const permissoesEstoque = (role) => ({
  operador: ROLES_ESTOQUE_OPERADOR.includes(role),
  financeiro: ROLES_ESTOQUE_FINANCEIRO.includes(role),
  admin: ROLES_ESTOQUE_ADMIN.includes(role),
});
